import { UPDATE_FILTERS } from 'constants/types';

import {
  safeAWSCallPatch,
  safeAWSCallDelete,
  safeAWSCallPost
} from 'helpers/firebaseSetup';

export function handleFavorite(id, handleError) {
  return async dispatch => {
    try {
      const response = await safeAWSCallPatch(
        '/customers/filters/toggle-filter-favorite',
        {
          id
        }
      );

      // throw an error if the response status is not 200
      if (response?.status !== 200) {
        throw new Error('Failed to update favorite status');
      }

      // update the filter's favorite status in the local state if the API call is successful
      dispatch({ type: 'UPDATE_FILTERS', payload: response.data });
    } catch (error) {
      console.error(error);
      if (handleError) handleError('Failed to update filter favorite status');
    }
  };
}

export function handleRenameFilter(id, newName, handleError) {
  return async dispatch => {
    try {
      const response = await safeAWSCallPatch('/customers/filters/rename', {
        id,
        name: newName.trim()
      });

      if (response?.status !== 200) {
        throw new Error('Failed to update filter name');
      }

      dispatch({
        type: UPDATE_FILTERS,
        payload: response.data
      });
    } catch (error) {
      console.error('Error updating filter name:', error);
      if (handleError) handleError('Failed to update filter name');
    }
  };
}

export function handleSaveFilter(
  agentId,
  name,
  description,
  json,
  tab,
  favorite = false,
  handleError
) {
  return async dispatch => {
    const newFilter = {
      agentId,
      name,
      description: description?.trim() || null,
      json,
      tab,
      favorite
    };
    try {
      const response = await safeAWSCallPost('/customers/filters', newFilter);

      if (response?.status !== 201) {
        throw new Error('Failed to save filter');
      }

      dispatch({ type: UPDATE_FILTERS, payload: response.data });
    } catch (error) {
      console.error('Error saving filter:', error);
      if (handleError) handleError('Failed to save filter');
    }
  };
}

export function handleUpdateFilter(id, name, description, json, handleError) {
  return async dispatch => {
    try {
      const response = await safeAWSCallPatch('/customers/filters', {
        id,
        name: name.trim(),
        description: description?.trim() || null,
        json
      });

      if (response?.status !== 200) {
        throw new Error('Failed to update filter');
      }

      dispatch({ type: UPDATE_FILTERS, payload: response.data });
    } catch (error) {
      console.error('Error updating filter:', error);
      if (handleError) handleError('Failed to update filter');
    }
  };
}

export function handleUpdateFilterJSON(id, json, handleError) {
  return async (dispatch, getState) => {
    const { filters } = getState();

    try {
      const response = await safeAWSCallPatch('/customers/filters/json', {
        id,
        json
      });

      if (response?.status !== 200) {
        throw new Error('Failed to update filter JSON');
      }

      const updatedFilters = filters.list.map(filter => {
        if (filter.id === id) {
          return { ...filter, json };
        }
        return filter;
      });

      dispatch({ type: UPDATE_FILTERS, payload: updatedFilters });
    } catch (error) {
      console.error('Error normalizing filter:', error);
      if (handleError) handleError('Failed to update filter JSON');
    }
  };
}

export function handleDeleteFilter(id, handleError, handleSuccess) {
  return async (dispatch, getState) => {
    const { list: filtersList } = getState().filters;
    try {
      const response = await safeAWSCallDelete('/customers/filters/', { id });

      if (response?.status !== 200) {
        throw new Error('Failed to delete filter');
      }

      const updatedFilters = filtersList.filter(filter => filter.id !== id);
      dispatch({ type: UPDATE_FILTERS, payload: updatedFilters });
      if (handleSuccess) handleSuccess();
    } catch (error) {
      console.error('Error deleting filter:', error);
      if (handleError) handleError('Failed to delete filter');
    }
  };
}
